export const APP_MENSAGENS = 'APP_MENSAGENS';
export const APP_ATIVIDADES = 'APP_ATIVIDADES';
export const APP_ALERTAS = 'APP_ALERTAS';
export const APP_ATU_ALERTAS = 'APP_ATU_ALERTAS';
export const APP_ATUALIZA = 'APP_ATUALIZA';
